import { MutableRefObject, Ref, useMemo, useRef } from 'react'

export const combineRefs =
  <T,>(...refs: Ref<T>[]): Ref<T> =>
  (value: T) => {
    refs.forEach(ref => {
      if (!ref) return
      if (typeof ref === 'function') {
        ref(value)
      } else {
        const mutableRef = ref as MutableRefObject<unknown>
        mutableRef.current = value
      }
    })
  }

export const useCombinedInputRef = (ref?: React.Ref<HTMLInputElement>) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const combinedRef = useMemo(() => (ref ? combineRefs(ref, inputRef) : inputRef), [ref])
  return { combinedRef, inputRef }
}
